export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.11.5-0958.25",
  commitId: "d857d00b31c452c322868050a5eb130d86957bb9",
  commitTime: "2026-11-05T09:58:25.000Z",
});
